import { Stack, useEventCallback } from '@mui/material';
import {
  type ExtendedGridColumnHeaderProps,
  ExtendedAutocomplete,
  ContainerPopper,
  useMultipleSelectorProps,
  useDataGridContext,
  FakeDropdownBox,
} from '@issuemanager/apps/client/components';
import { useState } from 'react';
import {
  IssueSeverityChip,
  IssueSeverityData,
  useIssueSeverities,
} from '../../../../issue/components/issue-severity-chip';

export function SLAsGridSeverityFilter(params: ExtendedGridColumnHeaderProps) {
  const options = useIssueSeverities(false);
  const context = useDataGridContext();
  const value: IssueSeverityData[] = context.filterModel[params.field] ?? [];

  const [partialValue, setPartialValue] = useState(value ?? []);

  const handleChange = useEventCallback((value) => {
    context.setFilterModel((prevState) => ({
      ...prevState,
      [params.field]: value,
    }));
  });

  const autocompleteProps = useMultipleSelectorProps({
    options,
    value,
    setValue: handleChange,
    partialValue,
    setPartialValue,
  });

  return (
    <ContainerPopper
      renderTarget={(props) => (
        <FakeDropdownBox onClick={props.handleClick}>
          {value.length ? (
            <Stack direction='row' spacing={0.5}>
              {value.map((v) => (
                <IssueSeverityChip key={v.id} severity={v.value} />
              ))}
            </Stack>
          ) : null}
        </FakeDropdownBox>
      )}
      renderChildren={(props) => (
        <ExtendedAutocomplete
          {...autocompleteProps}
          open
          options={options}
          getOptionLabel={(option) => option.label}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          renderOption={(_, option) => (
            <IssueSeverityChip severity={option.value} />
          )}
          onClose={props.handleClose}
          TextFieldProps={{
            autoFocus: true,
          }}
        />
      )}
    />
  );
}
